import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { SubscriptionsTab } from "@/components/admin/SubscriptionsTab";
import { ShipmentsTab } from "@/components/admin/ShipmentsTab";
import { LeadsTab } from "@/components/admin/LeadsTab";
import { InactiveCustomersTab } from "@/components/admin/InactiveCustomersTab";
import { PickupsTab } from "@/components/admin/PickupsTab";
import { useAuth } from "@/hooks/useAuth";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";

export default function Admin() {
  const { signOut } = useAuth();

  return (
    <div className="min-h-screen bg-background p-6 max-w-7xl mx-auto">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-foreground">Panel de Administración</h1>
        <Button variant="ghost" size="sm" onClick={signOut}>
          <LogOut className="h-4 w-4 mr-2" />
          Cerrar sesión
        </Button>
      </div>

      <Tabs defaultValue="subscriptions">
        <TabsList className="mb-4">
          <TabsTrigger value="subscriptions">Suscripciones</TabsTrigger>
          <TabsTrigger value="shipments">Envíos</TabsTrigger>
          <TabsTrigger value="pickups">Recogidas</TabsTrigger>
          <TabsTrigger value="leads">Leads</TabsTrigger>
          <TabsTrigger value="inactive">Inactivos</TabsTrigger>
        </TabsList>

        <TabsContent value="subscriptions">
          <SubscriptionsTab />
        </TabsContent>
        <TabsContent value="shipments">
          <ShipmentsTab />
        </TabsContent>
        <TabsContent value="pickups">
          <PickupsTab />
        </TabsContent>
        <TabsContent value="leads">
          <LeadsTab />
        </TabsContent>
        <TabsContent value="inactive">
          <InactiveCustomersTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
